var _a;
import { IdLoca } from "../../utils/i18n/IdLoca";
import { CoopMessageType } from "../../utils/network/generated/protoTypes";
export var MapLocaCoopMessage = (_a = {},
    _a[CoopMessageType.COOP_PROJECT_STARTED] = IdLoca.coopSystemMessage_projectStart,
    _a[CoopMessageType.COOP_PROJECT_COMPLETED] = IdLoca.coopSystemMessage_projectSuccessful,
    _a[CoopMessageType.COOP_PROJECT_STOPPED] = IdLoca.coopSystemMessage_projectCancelled,
    _a[CoopMessageType.COOP_PROJECT_FAILED] = IdLoca.coopSystemMessage_projectFailed,
    _a[CoopMessageType.COOP_LEVELED_UP] = IdLoca.coopSystemMessage_coopLevelUp,
    _a[CoopMessageType.COOP_PLAYER_JOINED] = IdLoca.coopSystemMessage_playerJoined,
    _a[CoopMessageType.COOP_PLAYER_DONATED] = IdLoca.coopSystemMessage_donatedFunds,
    _a[CoopMessageType.COOP_PLAYER_LEFT] = IdLoca.coopSystemMessage_playerLeft,
    _a[CoopMessageType.COOP_PLAYER_KICKED] = IdLoca.coopSystemMessage_playerKicked,
    _a[CoopMessageType.COOP_INVITED_PLAYER_JOINED] = IdLoca.coopSystemMessage_invitedPlayerJoined,
    _a[CoopMessageType.COOP_PLAYER_RANK_CHANGED] = IdLoca.coopSystemMessage_appointedDeputy,
    _a[CoopMessageType.COOP_PLAYER_LEADERSHIP] = IdLoca.coopSystemMessage_newLeader,
    _a[CoopMessageType.COOP_IMPROVEMENT_UPGRADE] = IdLoca.coopSystemMessage_improvementUpgraded,
    _a[CoopMessageType.COOP_BUFF_ACTIVATED] = IdLoca.coopSystemMessage_improvementStarted,
    _a);



//////////////////
// WEBPACK FOOTER
// ./src/features/cooperative/MapLocaCoopMessage.ts
// module id = 2619
// module chunks = 3